// Import packages
import React from "react";
import {Route, Switch, Router, Redirect} from "react-router-dom";

// Import utils
import {history} from "../configs/history";
import {ProtectedRoute} from "./protectedRoute";

// Import pages
import AdminLayout from '../containers/AdminLayout';
import Login from '../containers/Login';

import Dashboard from '../containers/Dashboard';

import NotFound from '../containers/NotFound';
import Contact from '../containers/Contact';

import Moderators from '../containers/moderators/Moderators';
import AddEditModerator from "../containers/moderators/AddEditModerator";

import Media from "../containers/media/Media";
import EditFile from "../containers/media/EditFile";

import Languages from "../containers/languages/Languages";
import EditLanguage from "../containers/languages/EditLanguage";

import Slider from "../containers/slider/Slider";
import AddEditSlider from "../containers/slider/AddEditSlider";

import Advertisement from "../containers/advertisement/Advertisement";
import AddEditAdvertisement from "../containers/advertisement/AddEditAdvertisement";

import StaticTexts from "../containers/staticTexts/StaticTexts";

import About from "../containers/about/About";

import AddEditBlog from "../containers/blogs/AddEditBlog";
import Subscribe from "../containers/subscribe/Subscribe";

import Menu from "../containers/menu/Menu";
import AddEditMenu from "../containers/menu/AddEditMenu";

import CustomPages from "../containers/customPages/CustomPages";
import AddEditCustomPages from "../containers/customPages/AddEditCustomPages";

// import Banner from "../containers/banner/Banner";
// import AddEditBanner from "../containers/banner/AddEditBanner";

// import Settings from '../containers/Settings';


export default () => {

    return <Router history={history}>
        <Switch>
            <Redirect exact from="/" to="/login"/>
            <Route exact path="/login" component={Login}/>
            <AdminLayout>
                <Switch>
                    <Route exact path="/blogs" component={Dashboard}/>
                    <ProtectedRoute exact path="/blogs/add" component={AddEditBlog}/>
                    <ProtectedRoute exact path="/blogs/edit/:id" component={AddEditBlog}/>

                    <ProtectedRoute exact path="/moderators" component={Moderators}/>
                    <ProtectedRoute exact path="/moderators/add" component={AddEditModerator}/>
                    <ProtectedRoute exact path="/moderators/edit/:id" component={AddEditModerator}/>

                    <ProtectedRoute exact path="/media" component={Media}/>
                    <ProtectedRoute exact path="/media/edit/:id" component={EditFile}/>

                    <ProtectedRoute exact path="/slider" component={Slider}/>
                    <ProtectedRoute exact path="/slider/add" component={AddEditSlider}/>
                    <ProtectedRoute exact path="/slider/edit/:id" component={AddEditSlider}/>

                    <ProtectedRoute exact path="/advertisement" component={Advertisement}/>
                    <ProtectedRoute exact path="/advertisement/add" component={AddEditAdvertisement}/>
                    <ProtectedRoute exact path="/advertisement/edit/:id" component={AddEditAdvertisement}/>

                    <ProtectedRoute exact path="/languages" component={Languages}/>
                    <ProtectedRoute exact path="/languages/edit/:id" component={EditLanguage}/>

                    <ProtectedRoute exact path="/contact" component={Contact}/>
                    <ProtectedRoute exact path="/staticTexts" component={StaticTexts}/>

                    <ProtectedRoute exact path="/about" component={About}/>

                    <ProtectedRoute exact path="/menu" component={Menu}/>
                    <ProtectedRoute exact path="/menu/add" component={AddEditMenu}/>
                    <ProtectedRoute exact path="/menu/edit/:id" component={AddEditMenu}/>

                    <ProtectedRoute exact path="/subscribe" component={Subscribe}/>

                    {/*<ProtectedRoute exact path="/banner" component={Banner}/>*/}
                    {/*<ProtectedRoute exact path="/banner/add" component={AddEditBanner}/>*/}
                    {/*<ProtectedRoute exact path="/banner/edit/:id" component={AddEditBanner}/>*/}

                    <ProtectedRoute exact path="/customPages" component={CustomPages}/>
                    <ProtectedRoute exact path="/customPages/add" component={AddEditCustomPages}/>
                    <ProtectedRoute exact path="/customPages/edit/:id" component={AddEditCustomPages}/>

                    {/*<ProtectedRoute exact path="/settings" component={Settings}/>*/}

                    <Route exact path="/404" component={NotFound}/>
                    <Route component={NotFound}/>
                </Switch>
            </AdminLayout>
        </Switch>
    </Router>
}
